/**
 * 産廃回収詳細 回収日編集
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifest/managements`

const manifest_management_transport_location = {
  namespaced: true,
  actions: {
    /**
     * 編集データの取得
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/transport_locations/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 受注登録 更新
     * @param commit
     * @param id
     * @param params
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id, params }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/transport_locations/${id}`
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}
export default manifest_management_transport_location
